module.exports = __webpack_public_path__ + "img/img_ghost_02@3x.fba7d718.png";